'use strict';
/* eslint-disable no-console */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
function start() {
  return function () {
    console.log('App Started!');
    // TODO: dispatch other starting actions here
    // e.g. dispatch(actionCreator());
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/AppActions.js
// module id = 444
// module chunks = 0